import { render, staticRenderFns } from "./AppPageOptionBox.vue?vue&type=template&id=7bc9f0df&scoped=true&"
import script from "./AppPageOptionBox.vue?vue&type=script&lang=js&"
export * from "./AppPageOptionBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc9f0df",
  null
  
)

export default component.exports